// Offline-Verfügbarkeit für Gratis-Workouts.
//
// Strategie: Der Service Worker (sw.js) cached `/api/public/*` (Network-First) und
// `/api/media/{id}/file` (Cache-First). „Für Offline speichern" wärmt diese Caches
// gezielt vor (Workout-JSON + alle zugehörigen Medien), damit ein Workout auch ohne
// Netz abspielbar ist – ohne dass der Nutzer es vorher im Presenter geöffnet haben muss.
// Welche Workouts der Nutzer offline behalten will, wird in localStorage vermerkt.
import { getFreeWorkout } from '../api/public';
import { getMediaFileUrl } from '../api/media';

const KEY = 'mkw_offline_free_workouts';

export function listOfflineIds() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(raw) ? raw.map(Number) : [];
  } catch {
    return [];
  }
}

export function isSavedOffline(id) {
  return listOfflineIds().includes(Number(id));
}

function setOfflineIds(ids) {
  localStorage.setItem(KEY, JSON.stringify([...new Set(ids.map(Number))]));
}

// Sammelt alle Media-IDs (Übungs- und Intro-Medien), die als Datei vorliegen.
function collectMediaIds(workout) {
  const ids = [];
  (workout.phases || []).forEach((p) =>
    (p.rounds || []).forEach((r) =>
      (r.sets || []).forEach((s) =>
        (s.items || []).forEach((it) => {
          (it.exercise?.media || []).forEach((m) => {
            const mid = m.media?.id || m.media_id;
            if (mid) ids.push(mid);
          });
        })
      )
    )
  );
  (workout.intro_media || []).forEach((m) => {
    if (m.media_id) ids.push(m.media_id);
  });
  return [...new Set(ids)];
}

// Lädt Workout-JSON + Medien in die SW-Caches und merkt das Workout als offline vor.
export async function saveForOffline(id) {
  const workout = await getFreeWorkout(id); // SW cached die JSON-Antwort
  const mediaIds = collectMediaIds(workout);
  // Medien parallel anfragen → SW legt sie Cache-First ab. Fehler ignorieren
  // (externe URLs/YouTube haben keine Datei und sind nicht erforderlich).
  await Promise.all(mediaIds.map((mid) => fetch(getMediaFileUrl(mid)).catch(() => {})));
  setOfflineIds([...listOfflineIds(), id]);
  return workout;
}

export function removeOffline(id) {
  setOfflineIds(listOfflineIds().filter((x) => x !== Number(id)));
}
